import { Mark } from '@tiptap/core'
import { Plugin, PluginKey } from 'prosemirror-state'

export const PasteUrlExtension = Mark.create({
  name: 'pasteUrl',

  priority: 1000,

  inclusive: false,

  addOptions() {
    return {
      HTMLAttributes: {
        target: '_blank',
        rel: 'noopener noreferrer nofollow',
      },
    }
  },

  addAttributes() {
    return {
      href: {
        default: null,
      },
      target: {
        default: this.options.HTMLAttributes.target,
      },
      rel: {
        default: this.options.HTMLAttributes.rel,
      },
    }
  },

  parseHTML() {
    return [{ tag: 'a[href]:not([href *= "javascript:" i])' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['a', HTMLAttributes, 0]
  },

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('pasteUrl'),
        props: {
          handlePaste: (view, event) => {
            const clipboardData = event.clipboardData
            if (!clipboardData) return false

            const pastedData = clipboardData.getData('text/plain')

            const urlPattern = /^(https?:\/\/[^\s]+)$/
            if (!urlPattern.test(pastedData)) {
              return false
            }

            const { from, to } = view.state.selection
            if (from === to) {
              return false
            }

            const tr = view.state.tr
            const mark = this.type.create({ href: pastedData })

            tr.removeMark(from, to, this.type)
            tr.addMark(from, to, mark)

            event.preventDefault()
            view.dispatch(tr)

            return true
          },
        },
      }),
    ]
  },
})
